// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6d9b48a","880":"cdbf18ea"}[chunkId] + ".chunk.js";
};